import * as React from 'react'
import {
    forwardRef,
    RefObject,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
} from 'react'
import {
    default as ContentDossierIndex,
    ContentDossierIndexHandle,
} from '../ContentDossier/Index/ContentDossierIndex'
import { Alert, Menu, MenuItem } from '@mui/material'
import { Link } from 'react-router-dom'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/pro-duotone-svg-icons/faCalendar'
import { faClipboardList } from '@fortawesome/pro-duotone-svg-icons/faClipboardList'
import { faList } from '@fortawesome/pro-duotone-svg-icons/faList'
import { faPlus } from '@fortawesome/pro-duotone-svg-icons/faPlus'
import { faTasks } from '@fortawesome/pro-duotone-svg-icons/faTasks'
import { faRotate } from '@fortawesome/pro-duotone-svg-icons/faRotate'
import { faCaretDown } from '@fortawesome/pro-duotone-svg-icons/faCaretDown'

import SearchDefDossier from '@/feature/DefDossier/Utils/SearchDefDossier'
import { toast } from 'react-toastify'
import { ToastOptions } from 'react-toastify/dist/types'
import DefDossierKanban from '@/feature/DefDossier/Index/Components/DefDossierKanban'
import DefDossierTimeline from '@/feature/DefDossier/Index/Components/DefDossierTimeline'
import DefDossierGanttChart from '@/feature/DefDossier/Index/Components/DefDossierGanttChart'
import DefDossierCalender from '@/feature/DefDossier/Index/Components/DefDossierCalender'
import { useSocketService } from '../../context/SocketServiceContext'
import CreateContentDossier from '../ContentDossier/Create/CreateContentDossier'
import Loading from '../../Components/Elements/Loading/LoadingData'
import ContentDossier from '../ContentDossier/Detail/ContentDossier'

import AppDialog from '@/Components/AppDialog/AppDialog'
import {
    StyledButton,
    CompactButton,
    FilterToggleButton,
} from '@/Components/Elements/StyledComponents/Buttons'

const EmbeddedLinkField = forwardRef((props: any, ref) => {
    const socketService = useSocketService()
    let curRef = useRef<ContentDossierIndexHandle>(null)
    const [result, setResult] = useState([])
    const [addDossier, setAddDossier] = useState(false)
    const [isRefreshing, setIsRefreshing] = useState(false)
    const [localView, setLocalView] = useState(
        props.item && props.item.settings?.views?.length === 1
            ? props.item.settings.views[0]
            : 'list'
    )
    const [showEmail, setShowEmail] = useState(
        props.item &&
            props.item.settings &&
            props.item &&
            props.item.settings.show_email === true
            ? true
            : false
    )

    const [dataRefresh, setDataRefresh] = useState(
        props.item &&
            props.item.settings &&
            props.item &&
            props.item.settings.data_refresh === true
            ? true
            : false
    )

    const [hasRowInput, setHasRowInput] = useState(
        props.item &&
            props.item.settings &&
            props.item &&
            props.item.settings.row_input === true
            ? true
            : false
    )

    const [dossierQuery, setDossierQuery] = useState(null)
    const [search, setSearch] = useState(null)
    const [searchItems, setSearchItems] = useState([])
    const [searchItemsLoading, setSearchItemsLoading] = useState(false)
    const [showFilter, setShowFilter] = useState(false)
    const [loading, setLoading] = useState(false)
    const [dpChildMain, setDpChildMain] = useState(null)
    const [multiAdd, setMultiAdd] = useState(false)
    const [pager, setPager] = useState({})
    const [dossierId, setDossierId] = useState<number>()
    const [anchorEl, setAnchorEl] = React.useState(null)

    const toastOptions = {
        position: 'bottom-center',
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    } as ToastOptions

    const getCurrentRef = (): RefObject<any> => {
        if (!curRef) {
            curRef = React.createRef()
        }

        return curRef
    }

    const onSuccess = (dossierId) => {
        setTimeout(() => {
            socketService.displayItem.update({
                dossierId: dossierId,
                sender: socketService.socket()?.id,
                displayItem: props.item.id,
            })

            if (curRef && curRef.current) {
                curRef.current.fetchNewDossier(dossierId)
            }
        }, 100)
        setAddDossier(false)
    }

    const loadSocketCallbacks = () => {
        socketService.displayItem.refreshListener((data) => {
            if (
                socketService.socket().id !== data.sender.id &&
                data.displayItem === props.item.id
            ) {
                if (curRef && curRef.current) {
                    curRef.current.fetchNewDossier(data.dossierId)
                }

                if (props.kedo.user().getUserId() !== data.sender.userId) {
                    toast.success(
                        props.kedo.t('dossier_errors.success_create_ws', {
                            username: data.sender.username,
                        }),
                        toastOptions
                    )
                }
            }
        })
    }

    useEffect(() => {
        if (props.item?.settings?.embedded_single_view === true) {
            fetchOtherDisplayPositions()
        }

        return () => {
            socketService.displayItem.removeDdiListeners()
        }
    }, [])

    useEffect(() => {
        if (!dataRefresh) {
            return
        }

        let cancelled = false
        let timeoutId: NodeJS.Timeout | null = null

        const scheduleRefresh = (delay: number) => {
            timeoutId = setTimeout(async () => {
                if (cancelled) {
                    return
                }

                if (curRef.current?.refreshResults) {
                    await curRef.current.refreshResults(true)
                }

                if (!cancelled) {
                    scheduleRefresh(10000)
                }
            }, delay)
        }

        scheduleRefresh(500)

        return () => {
            cancelled = true
            if (timeoutId) {
                clearTimeout(timeoutId)
            }
        }
    }, [dataRefresh])

    const isShowMultiAdd = () => {
        const settings = props.item.settings
        if (
            settings &&
            settings.show_multi_add &&
            settings.show_multi_add === true
        ) {
            return true
        }

        return false
    }

    const isHideAdd = () => {
        const settings = props.item.settings
        if (settings && settings.hide_add && settings.hide_add === true) {
            return true
        }

        return false
    }

    const fetchSearchFilterItems = async () => {
        const api = props.kedo.api()
        const params = {
            params: {
                view: ['search', 'advanced-search'],
                defDossier: props.item.def_dossier_link.child_def_dossier_id,
            },
        }

        setSearchItemsLoading(true)

        await api
            .getCached(api.getDisplayItemEndpoint(), params)
            .then((response) => {
                setSearchItemsLoading(false)
                setSearchItems(response.data.results)
            })
    }

    const renderAddDossier = () => {
        const kedo = props.kedo
        let defDossier = null
        if (
            props.item.def_dossier_link &&
            props.item.def_dossier_link.child_def_dossier_id
        ) {
            defDossier = props.kedo
                .env()
                .getDefDossierById(
                    props.item.def_dossier_link.child_def_dossier_id
                )
        }

        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'lg'}
                fullWidth
                title={`${kedo.t('New')} ${
                    defDossier
                        ? kedo.env().translateItem(defDossier, 'defdossier')
                        : kedo.t('Dossier').toLowerCase()
                }${
                    props.item.def_dossier_link?.child_def_dossier_name
                        ? ` ${props.item.def_dossier_link.child_def_dossier_name}`
                        : ''
                }`}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        setAddDossier(false)
                    }
                }}
                headerClose={() => setAddDossier(false)}
                contentProps={{ dividers: true }}
            >
                <CreateContentDossier
                    kedo={kedo}
                    props={{
                        ...props,
                        multiAdd: multiAdd,
                        defDossierId:
                            props.item.def_dossier_link.child_def_dossier_id,
                        embeddedDefDossierId: props.item.def_dossier_id,
                        leftSideBar:
                            props.item.settings &&
                            props.item.settings.passing_sidebar
                                ? props.item.settings.passing_sidebar
                                : null,
                        embedded: props.dossier.id,
                        embeddedFieldId: props.item.id,
                        linkId: props.item.def_dossier_link.back_link_id,
                        location: 'EmbeddedLinkField',
                        onClose: () => setAddDossier(false),
                        onSuccess: onSuccess,
                    }}
                />
            </AppDialog>
        )
    }

    useEffect(() => {
        if (curRef && curRef.current) {
            if (search || dossierQuery)
                curRef.current.doSearch(search, dossierQuery)
        }
    }, [search, dossierQuery])

    const onChangeLocalView = (view) => {
        setLocalView(view)
    }

    const doSearch = (values, dossierQuery) => {
        setSearch(values)
        setDossierQuery(dossierQuery)
    }

    useImperativeHandle(ref, () => ({
        doSearch,
    }))

    const getFilterButton = () => {
        return (
            <FilterToggleButton
                dense={false}
                variant="contained"
                active={
                    (Array.isArray(search)
                        ? search.length > 0
                        : Boolean(search)) ||
                    Boolean(dossierQuery) ||
                    showFilter
                }
                aria-label={props.kedo.t('Filter')}
                onClick={() => {
                    if (!showFilter) {
                        fetchSearchFilterItems()
                    }
                    setShowFilter((prevState) => {
                        return !prevState
                    })
                }}
                loading={searchItemsLoading}
            />
        )
    }

    const getViews = () => {
        if (
            !props.item.settings ||
            !props.item.settings.views ||
            !Array.isArray(props.item.settings.views)
        ) {
            return ['list']
        }

        return props.item.settings.views
    }

    const renderShow = () => {
        const kedo = props.kedo

        const isAllowedToAdd = () => {
            return kedo
                .env()
                .isAllowedDefDossier(
                    'create',
                    props.item.def_dossier_link.child_def_dossier_id,
                    kedo.user()
                )
        }

        const views = getViews()
        let viewIcon = faList

        if (localView === 'calendar') {
            viewIcon = faCalendar
        } else if (localView === 'kanban') {
            viewIcon = faTasks
        } else if (localView === 'gantt') {
            viewIcon = faClipboardList
        }

        return (
            <>
                {views.length > 1 ? (
                    <>
                        <StyledButton
                            endIcon={
                                <FontAwesomeIcon icon={faCaretDown} size="sm" />
                            }
                            sx={{
                                height: '40px',
                                mb: 1,
                                '& .MuiButton-endIcon svg ': {
                                    fontSize: '16px',
                                },
                            }}
                            onClick={(e) => {
                                setAnchorEl(e.currentTarget)
                            }}
                        >
                            <FontAwesomeIcon icon={viewIcon} />
                        </StyledButton>

                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={() => setAnchorEl(null)}
                        >
                            {(views.includes('list') || views.length <= 0) && (
                                <MenuItem
                                    onClick={() => {
                                        onChangeLocalView('list')
                                        setAnchorEl(null)
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faList}
                                        style={{ marginRight: 8 }}
                                    />
                                    {kedo.t('List')}
                                </MenuItem>
                            )}

                            {(views.includes('calendar') ||
                                views.length <= 0) && (
                                <MenuItem
                                    onClick={() => {
                                        onChangeLocalView('calendar')
                                        setAnchorEl(null)
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faCalendar}
                                        style={{ marginRight: 8 }}
                                    />
                                    {kedo.t('Calendar')}
                                </MenuItem>
                            )}

                            {(views.includes('kanban') ||
                                views.length <= 0) && (
                                <MenuItem
                                    onClick={() => {
                                        onChangeLocalView('kanban')
                                        setAnchorEl(null)
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faTasks}
                                        style={{ marginRight: 8 }}
                                    />
                                    {kedo.t('Kanban')}
                                </MenuItem>
                            )}

                            {(views.includes('timeline') ||
                                views.length <= 0) && (
                                <MenuItem
                                    onClick={() => {
                                        onChangeLocalView('timeline')
                                        setAnchorEl(null)
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faClipboardList}
                                        style={{ marginRight: 8 }}
                                    />
                                    {kedo.t('Timeline')}
                                </MenuItem>
                            )}

                            {(views.includes('gantt') || views.length <= 0) && (
                                <MenuItem
                                    onClick={() => {
                                        onChangeLocalView('gantt')
                                        setAnchorEl(null)
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faClipboardList}
                                        style={{ marginRight: 8 }}
                                    />
                                    {kedo.t('Gantt Chart')}
                                </MenuItem>
                            )}

                            {(kedo.env().hasModule('hourregistration') &&
                                views.includes('hourregistration')) ||
                            views.length <= 0 ? (
                                <MenuItem
                                    onClick={() => {
                                        onChangeLocalView('hourregistration')
                                        setAnchorEl(null)
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faClipboardList}
                                        style={{ marginRight: 8 }}
                                    />
                                    {kedo.t('Hourregistration')}
                                </MenuItem>
                            ) : null}
                        </Menu>
                    </>
                ) : null}
                <div style={{ display: 'inline' }}>
                    {addDossier && isHideAdd() === false
                        ? renderAddDossier()
                        : null}
                    {showFilter ? renderFilter() : null}
                    {dataRefresh && isRefreshing ? (
                        <FontAwesomeIcon icon={faRotate} spin={isRefreshing} />
                    ) : null}
                </div>

                {localView === 'kanban' ? (
                    <DefDossierKanban
                        dossierQuery={dossierQuery}
                        ddiSort={
                            props.item && props.item.settings?.sort
                                ? props.item.settings?.sort
                                : null
                        }
                        embedded={props.dossier.id}
                        linkId={props.item.def_dossier_link.back_link_id}
                        defDossierId={
                            props.item.def_dossier_link.child_def_dossier_id
                        }
                        kedo={kedo}
                    />
                ) : null}
                {localView === 'timeline' ? (
                    <DefDossierTimeline
                        kedo={kedo}
                        defDossierId={
                            props.item.def_dossier_link.child_def_dossier_id
                        }
                        ddiSort={
                            props.item?.settings?.sort
                                ? props.item.settings?.sort
                                : null
                        }
                        dossierQuery={dossierQuery}
                        embedded={props.dossier ? props.dossier.id : null}
                        linkId={props.item.def_dossier_link.back_link_id}
                    />
                ) : null}
                {localView === 'calendar' ? (
                    <DefDossierCalender
                        kedo={kedo}
                        defDossierId={
                            props.item.def_dossier_link.child_def_dossier_id
                        }
                    />
                ) : null}
                {localView === 'gantt' ? (
                    <DefDossierGanttChart
                        kedo={kedo}
                        defDossierId={
                            props.item.def_dossier_link.child_def_dossier_id
                        }
                    />
                ) : null}
                {localView === 'list' ? (
                    <ContentDossierIndex
                        props={{
                            ...props,
                            defDossierId:
                                props.item.def_dossier_link
                                    .child_def_dossier_id,
                            dossierQuery: dossierQuery,
                            embedded: props.dossier ? props.dossier.id : null,
                            customView: props.item?.settings?.custom_view
                                ? props.item.settings.custom_view
                                : null,
                            filterDossier: getFilterButton(),
                            linkId: props.item.def_dossier_link.back_link_id,
                            mode: 'embeddedList',
                            searchParams: search,
                            ddiSort: props.item?.settings?.sort
                                ? props.item.settings?.sort
                                : null,
                            showEmail: showEmail,
                            onClick: (dossier) => {
                                window.location.href =
                                    '/contentdossier/' + dossier.id
                            },
                            addDossier:
                                isHideAdd() === false &&
                                isAllowedToAdd() &&
                                !props.dossier.archived ? (
                                    <CompactButton
                                        onClick={() => setAddDossier(true)}
                                    >
                                        <FontAwesomeIcon
                                            icon={faPlus}
                                            size="xs"
                                        />
                                    </CompactButton>
                                ) : null,
                            rowInput: hasRowInput,
                            multiAdd:
                                isShowMultiAdd() && isAllowedToAdd() ? (
                                    <StyledButton
                                        sx={{
                                            '& svg:first-of-type': {
                                                mr: 0.5,
                                            },
                                        }}
                                        title={kedo.t('Multi add')}
                                        onClick={() => {
                                            setAddDossier(true)
                                            setMultiAdd(true)
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faPlus}
                                            size="xs"
                                        />
                                        <FontAwesomeIcon
                                            icon={faPlus}
                                            size="xs"
                                        />
                                    </StyledButton>
                                ) : null,
                        }}
                        kedo={kedo}
                        forwardedRef={getCurrentRef()}
                    />
                ) : null}
            </>
        )
    }

    const isSingleSelect = () => {
        const settings = props.item.def_dossier_link.settings
        if (settings && settings.multiple && settings.multiple === true) {
            return false
        }

        return true
    }

    const renderEmbeddedView = () => {
        const kedo = props.kedo

        if (!isSingleSelect()) {
            return (
                <Alert severity={'warning'}>
                    {props.kedo.t('A embedded view can only contain one link')}
                </Alert>
            )
        }

        if (!dpChildMain) {
            return
        }

        if (props.value.length > 1) {
            return (
                <Alert severity={'warning'}>
                    {kedo.t(
                        'You cannot convert a multiselect to an embedded view'
                    )}
                </Alert>
            )
        } else if (props.value.length === 1 || dossierId) {
            const currentDossierId = dossierId || props.value[0].id
            return (
                <ContentDossier
                    props={{
                        //setEdit: this.props.mode === 'edit' || this.props.mode === 'show/edit' ? this.state.dpChildMain.id : false,
                        embeddedInlineSingle: true,
                        selectedTab: dpChildMain?.id,
                        existingUser: true,
                        showSaveClose: true,
                        modalized: true,
                        onClose: () => {
                            //Todo
                        },
                        dossierId: currentDossierId,
                        disableBreadcrumb: true,
                    }}
                    kedo={kedo}
                />
            )
        }

        if (!props.item?.def_dossier_link?.child_def_dossier_id) {
            return <span>Loading</span>
        }

        const allowedToAdd = props.kedo
            .env()
            .isAllowedDefDossier(
                'create',
                props.item.def_dossier_link.child_def_dossier_id
            )

        if (!allowedToAdd) {
            return <span>{props.kedo.t('No items found')}</span>
        }

        if (!dossierId && props.value.length === 0) {
            return (
                <CreateContentDossier
                    props={{
                        kedo: kedo,
                        multiAdd: multiAdd,
                        defDossierId:
                            props.item.def_dossier_link.child_def_dossier_id,
                        embeddedDefDossierId: props.item.def_dossier_id,
                        embedded: props.dossier.id,
                        embeddedFieldId: props.item.id,
                        linkId: props.item.def_dossier_link.back_link_id,
                        location: 'EmbeddedLinkField',
                        leftSideBar:
                            props.item.settings &&
                            props.item.settings.passing_sidebar
                                ? props.item.settings.passing_sidebar
                                : null,
                        onSuccess: (dosId: React.SetStateAction<number>) => {
                            setDossierId(dosId)
                            setLoading(true)
                            setTimeout(() => {
                                setLoading(false)
                            }, 500)
                        },
                        onClose: () => setAddDossier(false),
                    }}
                    kedo={props.kedo}
                />
            )
        }
    }

    const fetchOtherDisplayPositions = () => {
        const dpFetchUrl =
            props.kedo.api().getDisplayPositionEndpoint() +
            '?defDossier=' +
            props.item.def_dossier_link.child_def_dossier_id +
            '&limit=100'

        props.kedo
            .api()
            .getCached(dpFetchUrl)
            .then((response) => {
                const dpFetchMain = response.data.results.find(
                    (item) => item.type === 'main_content'
                )
                setDpChildMain(dpFetchMain)
            })
    }

    const getDefDossierFromId = (defDossierId) => {
        return props.kedo
            .env()
            .getCurrentEnvironmentDefDossiers()
            .find((item) => item.id === parseInt(defDossierId))
    }

    const renderFilter = () => {
        const items = searchItems.filter(
            (searchItem) =>
                searchItem.view === 'search' ||
                searchItem.view === 'advanced-search'
        )

        return searchItemsLoading ? null : (
            <div>
                <br />
                <SearchDefDossier
                    doSearch={doSearch}
                    dossierQuery={dossierQuery}
                    kedo={props.kedo}
                    defDossier={getDefDossierFromId(
                        props.item.def_dossier_link.child_def_dossier_id
                    )}
                    items={items}
                    resetSearch={() => setSearch(null)}
                    search={search}
                    location={'EmbeddedLinkField'}
                />
            </div>
        )
    }

    const renderList = () => {
        if (!props.value || props.value.length <= 0 || !props.value.map) {
            return ''
        }

        return (
            <ul>
                {props.value.map((item) => (
                    <li key={item.id}>
                        <Link to={'/contentdossier/' + item.id}>
                            {item.summary}
                        </Link>
                    </li>
                ))}
            </ul>
        )
    }

    if (!props.dossier || !props.dossier.id) {
        return ''
    }

    if (loading === true) {
        return <Loading kedo={props.kedo} />
    }

    if (props.item?.settings?.embedded_single_view === true) {
        return renderEmbeddedView()
    }

    if (props.mode === 'list') {
        return renderList()
    }

    return renderShow()
})

EmbeddedLinkField.displayName = 'EmbeddedLinkField'

export default EmbeddedLinkField
